(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crate-official-branding-v16"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const config = document.getElementById('crate-official-branding-v16');
    const root = document.getElementById('crate-scratch-v3');
    const canvas = root?.querySelector('#crate-v3-canvas');
    if (!config || !root || !canvas || root.dataset.officialBrandingInitialized) return;
    root.dataset.officialBrandingInitialized = '16';
    root.dataset.characterArtState = 'loading';
    const image = new Image();
    let ready = false;
    let touched = false;
    let painted = false;
    let stopped = false;
    let timeout;
    const markTouched = () => { touched = true; };
    canvas.addEventListener('pointerdown', markTouched, { capture: true, passive: true, once: true });
    const updateCopy = () => {
      if (root.dataset.ticketVersion !== '12') return false;
      if (root.dataset.copyVersion === '16') return true;
      const heading = root.querySelector('#crate-v3-scratch-title');
      const kicker = root.querySelector('#crate-v3-scratch > .crate-kicker');
      const stamp = root.querySelector('.crate-ticket-stamp');
      if (!heading || !kicker || !stamp) return false;
      const first = document.createElement('span');
      const second = document.createElement('span');
      first.textContent = config.dataset.first;
      second.textContent = config.dataset.second;
      heading.replaceChildren(first, second);
      const tag = document.createElement('span');
      tag.className = 'crate-hashtag';
      tag.textContent = config.dataset.hashtag;
      kicker.replaceChildren(tag, document.createTextNode(' / ' + config.dataset.welcome));
      stamp.textContent = config.dataset.hashtag;
      const claim = root.querySelector('#crate-v3-claim-copy .crate-kicker');
      if (claim) claim.textContent = config.dataset.claim;
      root.dataset.copyVersion = '16';
      return true;
    };
    const cleanup = () => {
      observer.disconnect();
      clearTimeout(timeout);
      canvas.removeEventListener('pointerdown', markTouched, true);
    };
    const fallback = () => {
      if (painted || stopped) return;
      stopped = true;
      updateCopy();
      root.dataset.characterArtState = 'original-coating-fallback';
      cleanup();
    };
    const paint = () => {
      if (!updateCopy() || !root.dataset.brandInitialized || !ready || painted || stopped) return;
      if (touched || canvas.hidden || Number(root.dataset.scratchPercent || 0) > 0) {
        stopped = true;
        root.dataset.characterArtState = 'kept-active-scratch';
        cleanup();
        return;
      }
      const context = canvas.getContext('2d');
      if (!context) { fallback(); return; }
      context.save();
      try {
        context.setTransform(canvas.width / 700, 0, 0, canvas.height / 316, 0, 0);
        context.globalCompositeOperation = 'source-over';
        context.globalAlpha = 1;
        const coating = context.createLinearGradient(0, 0, 700, 316);
        coating.addColorStop(0, '#dbd1be');
        coating.addColorStop(.48, '#c8bea9');
        coating.addColorStop(1, '#e2d8c6');
        context.fillStyle = coating;
        context.fillRect(0, 0, 700, 316);
        let seed = 16387;
        const random = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
        for (let index = 0; index < 7000; index++) {
          context.fillStyle = random() > .5 ? 'rgba(255,255,255,.12)' : 'rgba(31,27,20,.065)';
          context.fillRect(random() * 700, random() * 316, .5 + random() * 1.6, .5 + random() * 1.6);
        }
        context.strokeStyle = '#373229';
        context.lineWidth = 2;
        context.strokeRect(2, 2, 696, 312);
        context.lineWidth = 1;
        context.strokeRect(13, 13, 674, 290);
        context.fillStyle = '#171715';
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = '900 32px Arial, sans-serif';
        context.fillText(config.dataset.cover, 260, 143, 448);
        context.font = '700 13px Arial, sans-serif';
        context.fillText(config.dataset.note, 260, 181, 380);
        const spark = (x, y, radius) => {
          context.beginPath();
          context.moveTo(x, y - radius);
          context.quadraticCurveTo(x + 2, y - 2, x + radius * .7, y);
          context.quadraticCurveTo(x + 2, y + 2, x, y + radius);
          context.quadraticCurveTo(x - 2, y + 2, x - radius * .7, y);
          context.quadraticCurveTo(x - 2, y - 2, x, y - radius);
          context.fill();
        };
        context.fillStyle = '#b49755';
        spark(60, 58, 15);
        spark(44, 92, 7);
        spark(488, 58, 11);
        const height = 264;
        const width = height * image.naturalWidth / image.naturalHeight;
        context.drawImage(image, 700 - 28 - width, 26, width, height);
        painted = true;
        root.dataset.approvedArt = '16';
        canvas.dataset.approvedArt = '16';
        root.dataset.characterArtState = 'ready';
      } catch (_) {
        fallback();
      } finally {
        context.restore();
        cleanup();
      }
    };
    const observer = new MutationObserver(paint);
    observer.observe(root, { attributes: true, attributeFilter: ['data-brand-initialized', 'data-ticket-version'] });
    image.crossOrigin = 'anonymous';
    image.onload = () => { ready = true; paint(); };
    image.onerror = fallback;
    timeout = setTimeout(fallback, 15000);
    image.src = config.dataset.mascotUrl;
    if (image.complete && image.naturalWidth) { ready = true; paint(); }
    updateCopy();
    window.addEventListener('pagehide', () => { stopped = true; cleanup(); }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crate-scratch-v3"] && !Shopify.designMode) return;
  try {
    (() => {
 const initialize = () => {
  const root=document.getElementById('crate-scratch-v3');
  if(!root||root.dataset.brandInitialized)return;
  root.dataset.brandInitialized='11';
  const canvas=root.querySelector('#crate-v3-canvas'),context=canvas.getContext('2d'),next=root.querySelector('#crate-v3-next'),revealButton=root.querySelector('#crate-v3-reveal'),emailStep=root.querySelector('#crate-v3-email'),native=root.querySelector('#crate-v3-native'),consent=root.querySelector('#crate-v3-consent'),message=root.querySelector('#crate-v3-message'),codeActions=root.querySelector('#crate-v3-code-actions'),successCopy=root.querySelector('#crate-v3-success-copy'),claimCopy=root.querySelector('#crate-v3-claim-copy');
  let issuedCode='',timer=0,focused=false,down=false,finished=false,previousPoint=null;
  const visited=new Set();
  const reveal=()=>{finished=true;down=false;canvas.hidden=true;revealButton.hidden=true;next.hidden=false;};
  if(context){
   context.fillStyle='#b5ad9f';context.fillRect(0,0,600,240);let seed=197;
   const random=()=>{seed=seed*16807%2147483647;return seed/2147483647;};
   for(let i=0;i<2300;i++){context.fillStyle=random()>.5?'#fff2':'#1111';context.fillRect(random()*600,random()*240,random()*3+1,random()*2+1);}
   context.strokeStyle='#1112';context.lineWidth=1;
   for(let i=-100;i<800;i+=26){context.beginPath();context.moveTo(i,0);context.lineTo(i-110,240);context.stroke();}
   context.textAlign='center';context.fillStyle='#171717';context.font='bold 14px Arial';context.fillText(canvas.dataset.kicker,300,72);context.font='bold 35px Arial';context.fillText(canvas.dataset.title,300,129,550);context.font='12px Arial';context.fillText(canvas.dataset.note,300,169);context.strokeStyle='#171717';context.lineWidth=2;context.strokeRect(16,16,568,208);
  }
  const erase=(x,y)=>{
   context.globalCompositeOperation='destination-out';context.beginPath();context.arc(x,y,27,0,Math.PI*2);context.fill();
   for(let row=Math.max(0,Math.floor((y-27)/12));row<=Math.min(19,Math.floor((y+27)/12));row++)for(let col=Math.max(0,Math.floor((x-27)/12));col<=Math.min(49,Math.floor((x+27)/12));col++){if((col*12+6-x)**2+(row*12+6-y)**2<=27**2)visited.add(row*50+col);}
  };
  const scratch=event=>{
   if(!down||finished||!context)return;event.preventDefault();const rect=canvas.getBoundingClientRect();if(!rect.width||!rect.height)return;
   const x=(event.clientX-rect.left)*600/rect.width,y=(event.clientY-rect.top)*240/rect.height;
   if(previousPoint){const distance=Math.hypot(x-previousPoint.x,y-previousPoint.y),steps=Math.max(1,Math.ceil(distance/8));for(let i=1;i<=steps;i++)erase(previousPoint.x+(x-previousPoint.x)*i/steps,previousPoint.y+(y-previousPoint.y)*i/steps);}else erase(x,y);
   previousPoint={x,y};root.dataset.scratchPercent=String(Math.round(visited.size/10));if(visited.size>=600)reveal();
  };
  canvas.addEventListener('pointerdown',event=>{down=true;previousPoint=null;canvas.setPointerCapture(event.pointerId);scratch(event);});canvas.addEventListener('pointermove',scratch);const endScratch=()=>{down=false;previousPoint=null;};canvas.addEventListener('pointerup',endScratch);canvas.addEventListener('pointercancel',endScratch);revealButton.addEventListener('click',reveal);
  root.querySelector('.close-preview').addEventListener('click',()=>{root.dispatchEvent(new CustomEvent('crate:scratch-close'));});
  const legacyIds=['rich-text-01M4S5MH8HGEZEGHBCACSG1WW0','rich-text-01M4S5MH8PEA08H382EBSP1TZX','rich-text-01M4Q67T98TFYC28N632GX1MZG','rich-text-01M4Q67T9H2HQBA7NMWQ11C5JF'];
  const successIds=['rich-text-01M4S5MH9CQF4RQSWK7FF5CD9P','rich-text-01M4Q67TAXPNXRG41AM56MBX57'];
  const inspect=()=>{
   const form=native.querySelector('form[data-testid="klaviyo-form-UgUN5a"]');if(!form)return;
   for(const id of legacyIds)native.querySelector('#'+id)?.closest('[data-testid="form-row"]')?.classList.add('crate-native-legacy');
   const input=form.querySelector('input[type="email"]');
   if(input){const label=root.querySelector('#crate-v3-email-label');label.htmlFor=input.id;label.hidden=!successCopy.hidden;input.closest('[data-testid="form-component"]')?.classList.add('crate-native-email-component');form.querySelector('button[data-action-id]')?.closest('[data-testid="form-component"]')?.classList.add('crate-native-button-component');message.hidden=true;if(timer){clearTimeout(timer);timer=0;}if(!emailStep.hidden&&consent.checked&&!focused){input.focus({preventScroll:true});focused=true;}return;}
   const successText=successIds.map(id=>native.querySelector('#'+id)).find(Boolean);if(!successText)return;
   let codeComponent=null,code='';
   for(const component of form.querySelectorAll('[data-testid="form-component"]')){if(component.contains(successText))continue;const walker=document.createTreeWalker(component,NodeFilter.SHOW_TEXT);let node;while((node=walker.nextNode())){const value=node.nodeValue.trim();if(/^[A-Z0-9][A-Z0-9_-]{5,63}$/i.test(value)&&/\d/.test(value)&&/[a-z]/i.test(value)&&!/preview|example/i.test(value)&&value.toUpperCase()!=='WELCOME10_7D'&&node.parentElement?.getClientRects().length){code=value;codeComponent=component;break;}}if(code)break;}
   if(!code){message.hidden=false;message.textContent=root.dataset.codeWait;return;}
   issuedCode=code;codeComponent.classList.add('crate-native-coupon');successText.closest('[data-testid="form-row"]')?.classList.add('crate-native-legacy');claimCopy.hidden=true;successCopy.hidden=false;codeActions.hidden=false;root.querySelector('#crate-v3-consent-label').hidden=true;root.querySelector('#crate-v3-email-label').hidden=true;native.inert=false;native.setAttribute('aria-disabled','false');message.hidden=true;
   if(root.dataset.rewardReady!=='true'){root.dataset.rewardReady='true';root.dispatchEvent(new CustomEvent('crate:scratch-signup'));successCopy.querySelector('h2').focus({preventScroll:true});}
  };
  consent.addEventListener('change',()=>{native.inert=!consent.checked;native.setAttribute('aria-disabled',String(!consent.checked));inspect();});
  next.addEventListener('click',()=>{root.querySelector('#crate-v3-scratch').hidden=true;emailStep.hidden=false;consent.focus({preventScroll:true});inspect();if(!native.querySelector('input[type="email"]'))timer=setTimeout(()=>{if(!native.querySelector('form')){message.hidden=false;message.textContent=root.dataset.loadError;}},12000);});
  root.querySelector('#crate-v3-copy').addEventListener('click',async()=>{const feedback=root.querySelector('#crate-v3-copy-message');if(!issuedCode)return;try{await navigator.clipboard.writeText(issuedCode);feedback.textContent=root.dataset.copySuccess;}catch(_){feedback.textContent=root.dataset.copyError;}});
  let queued=false;const observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;inspect();});});observer.observe(native,{childList:true,subtree:true,characterData:true});window.addEventListener('pagehide',()=>{observer.disconnect();clearTimeout(timer);},{once:true});inspect();
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crate-ticket-v12"] && !Shopify.designMode) return;
  try {
    (() => {
  const decorate = () => {
    const root = document.getElementById('crate-scratch-v3');
    const template = document.getElementById('crate-ticket-v12-decoration');
    if (!root || !template || root.dataset.ticketVersion === '12') return;
    const scratch = root.querySelector('#crate-v3-scratch');
    const area = scratch?.querySelector('.scratch-area');
    const title = scratch?.querySelector('#crate-v3-scratch-title');
    if (!area || !title) return;
    const content = template.content.cloneNode(true);
    const ticket = content.querySelector('.crate-printed-ticket');
    const slot = content.querySelector('.crate-ticket-window');
    if (!ticket || !slot) return;
    scratch.insertBefore(content, area);
    slot.append(area);
    const first = document.createElement('span');
    const second = document.createElement('span');
    first.textContent = template.dataset.titleFirst;
    second.textContent = template.dataset.titleSecond;
    title.replaceChildren(first, second);
    const brandLine = scratch.querySelector('.crate-brand-line');
    const perks = root.querySelector('.perks');
    if (brandLine && perks) root.insertBefore(brandLine, perks);
    root.dataset.ticketVersion = '12';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate, { once: true });
  else decorate();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["crate-welcome-overlay-v15"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const dialog = document.getElementById('crate-welcome-overlay-v15');
    if (!dialog || dialog.dataset.initialized) return;
    dialog.dataset.initialized = '16';
    if (typeof dialog.showModal !== 'function') return;
    const closeButton = dialog.querySelector('.crate-overlay-close');
    const scroller = dialog.querySelector('.crate-overlay-scroll');
    const root = dialog.querySelector('#crate-scratch-v3');
    if (!closeButton || !scroller || !root) return;
    const storageKey = 'crate_welcome_suppressed_until_v16';
    const day = 24 * 60 * 60 * 1000;
    const readSuppression = () => {
      let stored = 0;
      try { stored = Number(localStorage.getItem(storageKey)) || 0; } catch (_) {}
      const cookie = document.cookie.split('; ').find((value) => value.startsWith(storageKey + '='));
      const cookieValue = cookie ? Number(cookie.slice(storageKey.length + 1)) || 0 : 0;
      return Math.max(stored, cookieValue);
    };
    const suppress = (days) => {
      const until = Math.max(readSuppression(), Date.now() + days * day);
      try { localStorage.setItem(storageKey, String(until)); } catch (_) {}
      document.cookie = storageKey + '=' + until + '; Path=/; Max-Age=' + Math.ceil((until - Date.now()) / 1000) + '; SameSite=Lax; Secure';
    };
    if (readSuppression() > Date.now()) return;
    const earliestOpen = performance.now() + Math.max(0, 5000 - performance.now());
    const signedUp = () => suppress(30);
    root.addEventListener('crate:scratch-signup', signedUp);
    window.addEventListener('klaviyoForms', (event) => {
      if (event.detail?.formId === 'UgUN5a' && event.detail?.type === 'submit') signedUp();
    });
    const priorFocus = document.activeElement;
    let saved = null;
    let opened = false;
    let outsideStart = false;
    let openTimer;
    const readProperties = (style, keys) => keys.map((key) => [key, style.getPropertyValue(key), style.getPropertyPriority(key)]);
    const restoreProperties = (style, entries) => {
      for (const [key, value, priority] of entries) {
        if (value) style.setProperty(key, value, priority);
        else style.removeProperty(key);
      }
    };
    const restorePage = () => {
      if (!saved) return;
      restoreProperties(document.body.style, saved.body);
      restoreProperties(document.documentElement.style, saved.html);
      const scrollBehavior = readProperties(document.documentElement.style, ['scroll-behavior']);
      document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(saved.x, saved.y);
      restoreProperties(document.documentElement.style, scrollBehavior);
      saved = null;
      if (priorFocus instanceof HTMLElement && priorFocus.isConnected) priorFocus.focus({ preventScroll: true });
    };
    const dismiss = () => {
      suppress(root.dataset.rewardReady === 'true' ? 30 : 5);
      opened = true;
      observer.disconnect();
      clearTimeout(openTimer);
      if (dialog.open) dialog.close();
      restorePage();
    };
    const outside = (event) => {
      if (event.target !== dialog) return false;
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    closeButton.addEventListener('click', dismiss);
    root.addEventListener('crate:scratch-close', dismiss);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
    dialog.addEventListener('close', restorePage);
    dialog.addEventListener('pointerdown', (event) => { outsideStart = outside(event); });
    dialog.addEventListener('click', (event) => { if (outsideStart && outside(event)) dismiss(); outsideStart = false; });
    root.querySelector('#crate-v3-next')?.addEventListener('click', () => { requestAnimationFrame(() => { scroller.scrollTop = 0; }); });
    const open = () => {
      if (opened || !root.dataset.brandInitialized || root.dataset.ticketVersion !== '12') return;
      if (performance.now() < earliestOpen) {
        clearTimeout(openTimer);
        openTimer = setTimeout(open, earliestOpen - performance.now());
        return;
      }
      if (readSuppression() > Date.now()) {
        observer.disconnect();
        clearTimeout(openTimer);
        return;
      }
      opened = true;
      observer.disconnect();
      clearTimeout(openTimer);
      const x = window.scrollX;
      const y = window.scrollY;
      saved = {
        x, y,
        body: readProperties(document.body.style, ['position', 'top', 'left', 'width', 'overflow']),
        html: readProperties(document.documentElement.style, ['overflow'])
      };
      dialog.showModal();
      document.documentElement.style.setProperty('overflow', 'hidden');
      document.body.style.setProperty('position', 'fixed');
      document.body.style.setProperty('top', `${-y}px`);
      document.body.style.setProperty('left', `${-x}px`);
      document.body.style.setProperty('width', '100%');
      document.body.style.setProperty('overflow', 'hidden');
      root.dataset.overlayVersion = '16';
      scroller.scrollTop = 0;
      closeButton.focus({ preventScroll: true });
    };
    const observer = new MutationObserver(() => {
      if (root.dataset.characterArtState === 'ready' || root.dataset.characterArtState === 'original-coating-fallback') open();
    });
    observer.observe(root, { attributes: true, attributeFilter: ['data-brand-initialized', 'data-ticket-version', 'data-character-art-state'] });
    openTimer = setTimeout(open, Math.max(0, earliestOpen - performance.now()));
    if (root.dataset.characterArtState === 'ready') open();
    window.addEventListener('pagehide', () => { observer.disconnect(); clearTimeout(openTimer); restorePage(); }, { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

})();
